<app-statement-add
  [partnerId]="partnerId"
  [ofwcaId]="ofwcaId"
  (statementCreated)="closeDialog($event)"
  [dialogRef]="dialogRef"
>
</app-statement-add>
